<template>
  <div class="admin-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="userModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="姓名" prop="displayName">
            <Input v-model="userModel.displayName" placeholder="输入姓名" />
          </FormItem>
          <FormItem label="登录用户名" prop="loginName">
            <Input v-model="userModel.loginName" placeholder="输入登录用户名" />
          </FormItem>
          <FormItem label="登录密码" prop="password">
            <Input v-model="userModel.password" type="password" placeholder="输入登录密码" />
          </FormItem>
          <FormItem label="重复登录密码" prop="rePassword">
            <Input v-model="userModel.rePassword" type="password" placeholder="重复输入登录密码" />
          </FormItem>
          <!-- <FormItem label="性别" prop="gender">
            <RadioGroup v-model="userModel.gender">
              <Radio :label="1" border>男</Radio>
              <Radio :label="2" border>女</Radio>
            </RadioGroup>
          </FormItem> -->
          <FormItem label="手机号" prop="mobile">
            <Input v-model="userModel.mobile" placeholder="输入手机号" />
          </FormItem>
          <!-- <FormItem label="邮箱" prop="email">
            <Input v-model="userModel.email" placeholder="输入E-mail" />
          </FormItem> -->
          <FormItem label="状态" prop="enabled">
            <i-switch v-model="userModel.enabled" size="large">
              <span slot="open">启用</span>
              <span slot="close">禁用</span>
            </i-switch>
          </FormItem>
          <FormItem label="CA序列号" prop="certCn">
            <Input v-model="userModel.certCn" placeholder="输入CA序列号" />
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
        <!-- <div class="avatar-section">
          <div class="student-avatar">
            <Icon type="md-person" :size="120" color="#ccc" />
          </div>
          <div class="padding-top-20"></div>
          <div class="avatar-upload">
            <Upload action="//jsonplaceholder.typicode.com/posts/">
              <Button icon="ios-cloud-upload-outline">上传头像</Button>
            </Upload>
          </div>
        </div> -->
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'user-new',
  props: {
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.userModel.password && value !== this.userModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      loading: false,
      userModel: {
        displayName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: 127,
        certCn: null,
        roleId: null
      },
      modelValidate: {
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  watch: {
  },
  mounted () {
    this.initRoles()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.userModel.passwordMd5 = this.$md5(this.userModel.password)
          await Api.Auth(this).addUser(this.userModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.userModel= {
                displayName: null,
                password: null,
                rePassword: null,
                passwordMd5: null,
                gender: 1,
                loginName: null,
                enabled: true,
                mobile: null,
                email: null,
                type: 127,
                certCn: null,
                roleId: null
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
